import { render, staticRenderFns } from "./DialogMsg.vue?vue&type=template&id=32ce8244&"
import script from "./DialogMsg.vue?vue&type=script&lang=js&"
export * from "./DialogMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports